import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-ideal",
  "use": "icon-arrow-ideal-usage",
  "viewBox": "0 0 56 24",
  "content": "<symbol viewBox=\"0 0 56 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-ideal\">\n    <g fill=\"#FFF\" fill-rule=\"evenodd\">\n        <path d=\"M16 12 0 24V0z\" />\n        <path opacity=\".601\" d=\"M36 12 20 24V0z\" />\n        <path opacity=\".302\" d=\"M56 12 40 24V0z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol